import React, {  useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from "react-router-dom";
// import RemarkIcon from "./icons/remaks.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageLoader from "../loader/PageLoader";
import axiosInstance from "../../api/axiosInstance.js";

export default function StaffTask() {

  const location = useLocation();
  // const [requestData,setRequestData] = useState([]); 
  const [close,setClose] = useState("");
  const [message,setMessage] = useState("");


  // This will give you the query string part of the URL (e.g., '?id1=123&id2=456')
  const searchParams = new URLSearchParams(location.search);
  
  // Get Ids and Request Type 
  const guestRequestId = searchParams.get("guestRequestId") || "";
  const staffMemberId = searchParams.get("staffMemberId") || "";
  const requestType = searchParams.get("type") || ""; 
  const requestArray = ["food","custom","housekeeping","restaurantTable","spa","wakeupCall"];


  useEffect(()=>{
    if(requestType===""|| staffMemberId ==="" ||guestRequestId===""){
      setClose("requestClose");
      setMessage("Please Provide Necessary Details")
    }
    else if(!requestArray.includes(requestType)){
      setClose("requestClose");
      setMessage("Please Provide Correct Request")
    }
  },[]);
 


  // console.log("Guest Id : " + guestRequestId);
  // console.log("Staff Id : " + staffMemberId);
  // console.log("Request Type : " + requestType);

 
  
  // Fetch data function for react-query
  
  const fetchData = async () => {
    const baseUrl = `/api/v1/staff-members/${staffMemberId}`;
    
    let url;
    switch (requestType) {
      case "food":
        url = `${baseUrl}/food-request?guest_request_id=${guestRequestId}`;
        break;
      case "custom":
        url = `${baseUrl}/custom-request?guest_request_id=${guestRequestId}`;
        break;
      case "housekeeping":
        url = `${baseUrl}/housekeeping-request?guest_request_id=${guestRequestId}`;
        break;
      case "restaurantTable":
        url = `${baseUrl}/restaurant-table-request?guest_request_id=${guestRequestId}`;
        break;
      case "spa":
        url = `${baseUrl}/spa-request?guest_request_id=${guestRequestId}`;
        break;
      case "wakeupCall":
        url = `${baseUrl}/wakeup-call-request?guest_request_id=${guestRequestId}`;
        break;
      default:
        throw new Error("Please Provide a Valid Request Type");
    }

    try{
      const response = await axiosInstance.get(url);
      if(requestType==="housekeeping"){
   
        return response.data.data;
      }
      if(requestType==="restaurantTable"){
   
        return response.data.data;
      }
      if(requestType==="spa"){
        return response.data.data;
      }
      if(requestType==="wakeupCall"){
        // console.log("Response Wake Up Call :",response.data.data);
        return response.data.data;
      }

      else{
        return response.data;
      }
    
    }catch(error){
      if (error.response?.data?.message === "Request already closed") {
        console.log("Error : ",error)
        setClose("requestClose");
        setMessage(error.response?.data?.message)
      }
      if(error.response?.data?.message === "Custom request not found"){
        console.log("Error : ",error)
        setClose("requestClose");
        setMessage(error.response?.data?.message)
      }
      if(error.response?.data?.message === "Food request not found"){
        console.log("Error : ",error)
        setClose("requestClose");
        setMessage(error.response?.data?.message)
      }
      if(error.response?.data?.message === "Spa request not found"){
        console.log("Error : ",error)
        setClose("requestClose");
        setMessage(error.response?.data?.message)
      }
      if(error.response?.data?.message === "Restaurant Table request not found"){
        console.log("Error : ",error)
        setClose("requestClose");
        setMessage(error.response?.data?.message)
      }
      
      if(error.response?.data?.message === "Wake up call request not found"){
        console.log("Error : ",error)
        setClose("requestClose");
        setMessage(error.response?.data?.message)
      }



      setClose("requestClose");
      setMessage(error.response?.data?.message || "Some Error Occured")


      console.log(error);
      
      return { message: error }; // Return a fallback value in case of error
    }

  };

  const { data: requestData, error, isLoading,isFetching } = useQuery({
    queryKey: ['fetchData', { staffMemberId, requestType, guestRequestId }],
    queryFn: fetchData,
    refetchInterval: 3000, // Refetch every 6 seconds
    staleTime: 30000,       // Data is fresh for 30 seconds
    onError: (error) => {
      if (error.response?.data?.message === "Request already closed") {
        console.log("Error : ",error)
        setClose("requestClose");
        setMessage(error.response?.data?.message);
      }
      console.error(error);     
    }
  });
 

 
 
  const acceptRequest = async()=>{

    try{

      await axiosInstance.put(`/api/v1/staff-members/${staffMemberId}/guest-requests/${guestRequestId}/status`,{
        staff_status: "StaffAccepted",
        staff_remarks: ""
      });
      // console.log("Response : ",response.data);
      toast.success("Staff Accepted The Request Successfully");

    }catch(error){
      console.log(error);
      toast.error(error?.response?.data?.message || "Some Error Occured");

    }

  }

  const rejectRequest = async()=>{

    try{
      await axiosInstance.put(`/api/v1/staff-members/${staffMemberId}/guest-requests/${guestRequestId}/status`,{
        staff_status: "StaffDeclined",
        staff_remarks: ""
      });
      // console.log("Response : ",response.data);
      toast.success("Staff Rejected The Request Successfully");
    }
    catch(error){
      console.log(error)
      toast.error(error?.response?.data?.message || "Some Error Occured");
    }
  }

  const completeRequest = async()=>{
    try{
      await axiosInstance.put(`/api/v1/staff-members/${staffMemberId}/guest-requests/${guestRequestId}/status`,{
        staff_status: "StaffCompleted",
        staff_remarks: ""
      });
      // console.log("Response : ",response.data);
      toast.success("Staff Completed The Request Successfully");
    }
    catch(error){
      console.log(error);
      toast.error(error?.response?.data?.message || "Some Error Occured");
    }
  }


  // Function to format the date (e.g., "07 Oct")
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    return `${day} ${month}`;
  };

  // Function to format the time (e.g., "22:11")
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
  
  if(!isFetching){
     
    if(isLoading){
  
      return <div className="flex justify-center items-center m-auto h-screen w-full">
        <PageLoader/>
      </div>
  
    }
  }

  const getErrorMessage = ()=>{
    if(message==="Request already closed"){
      return "Request Closed";
    }else{
      return message;
    }
  }
  
 
  return (

  <>

    <ToastContainer />

    {close === "requestClose" ? 
      <div className='flex justify-center items-center h-screen font-bold'>
        <h1 className='text-3xl text-center px-4'>{getErrorMessage()}</h1>
      </div>
    : 
      <div className="staffTask pt-20 w-full">
        <div className='staffTask-main flex flex-col justify-center '>
          
          <h1 className='md:text-3xl sm:text-lg tracking-wide text-center px-4 '>
            A New Task Has Been Assigned To You 
          </h1>

          
          {/* Request Details */}
          <div className='roomData w-3/4 mx-auto mt-14'>

            {requestData?.delivery_room && 
              <h2><span className='font-bold'>Service Room  : </span> {requestData.delivery_room || "Room Number"}</h2>
            }
            {requestData?.service_room && 
              <h2><span className='font-bold'>Service Room  : </span> {requestData.service_room || "Room Number"}</h2>
            }

            {requestData?.type &&  
              <h2><span className="font-bold">Request</span> : {requestData.type || "Type"}</h2>
            }
            {
              requestData?.housekeeping_service_name &&
              <h2><span className="font-bold">Service Name : </span> {requestData.housekeeping_service_name || "housekeeping service name"}</h2>
            }
            {
              requestData?.number_of_people &&
              <h2><span className="font-bold">Number of People : </span> {requestData.number_of_people || "People"}</h2>
            }
            {
              requestData?.preferred_time &&
              <h2><span className="font-bold">Preferred Time : </span> {formatDate(requestData?.preferred_time) || "Date"} {formatTime(requestData?.preferred_time) || "Time" } </h2>
            }
  
            {/* Wake Up Call */}
            {
              requestType==="wakeupCall" && <div>
                <h4>
                  <span className="font-bold">Request Type</span> : Wake Up Call
                </h4>
              </div>
            }
            {
              requestData?.date_time && <div>
                <h4>
                  <span className="font-bold">Wake Up Date And Time</span> :   {formatDate(requestData?.date_time) || "Date"} {formatTime(requestData?.date_time) || "Time"}
                </h4>
              </div>
            }
   
          </div>


         
 
          {/*  Data */}
          <div className='task-details mt-5 flex flex-wrap justify-center gap-4 w-3/4 border mx-auto px-3'>
            
            {/* Food */}
            {requestData?.food_items && 
              <div className='foodData bg-[#F2F7FF] flex-1 p-4 min-w-[200px] h-fit'>
                <div className='foodData-header text-center'>
                  <h4>Food Items</h4>
                </div>
                <div className='foodData-para text-[#262B33] text-sm mt-4 text-center'>
                  {requestData.food_items.map((item, index) => (
                    <p className='mt-1' key={index}>{item.name} x {item.quantity}</p>
                  ))}
                </div>
              </div>
            }


            {requestData?.type==="Spa" && 
              <div className='foodData bg-[#F2F7FF] flex-1 p-4 min-w-[200px] h-fit'>
                <div className='foodData-header text-center'>
                  <h4>Spa Request Details</h4>
                </div>
                <div className='foodData-para text-[#262B33] text-sm mt-4 text-center'>
                
                    {
                      requestData?.spa_type &&
                      <h2 className='mt-2'><span className="font-bold">Spa Type : </span>{requestData.spa_type || "Spa Type"}</h2>
                    }
                    {
                      requestData?.spa_name &&
                      <h2 className='mt-2'><span className="font-bold">Spa Name : </span>{requestData.spa_name || "Spa Name"}</h2>
                    }

                  
                </div>
              </div>
            }


            {/* Custom */}
            {
              requestData?.request_details && 
              <div className='foodData bg-[#F2F7FF] flex-1 p-4 min-w-[200px] h-fit'>
                <div className='foodData-header text-center'>
                  <h4>Custom Request Details</h4>
                </div>
                <div className='foodData-para text-[#262B33] text-sm mt-4 text-center'>
                  {
                    requestData?.request_details &&
                    <p className='text-sm'>
                      {requestData?.request_details || 'Request Details'}
                    </p>
                  }
                </div>
              </div>

            }



            {/* For HouseKeeping */}

            {/* House Keeping Services Description */}
            {requestData?.housekeeping_service_description && 
              <div className='remarks bg-[#F2F7FF] flex-1 min-w-[200px] h-fit p-4'>
                <div className=''>
                  <h4>Housekeeping Service Description:</h4>
                </div>

                <div className='remarks-details mt-4 text-[#262B33]'>
                  <p className='text-xs'>
                    {requestData.housekeeping_service_description || "Housekeeping Description"}
                  </p>
                </div>
              </div>
            }

 

            {/* Common */}
            {/* Additional Comments */}
            {requestData?.additional_comments && 
              <div className='remarks bg-stone-300 flex-1 min-w-[200px] h-fit p-4'>
                <div className=''>
                  <h4>Additional Comments:</h4>
                </div>

                <div className='remarks-details mt-4 text-[#262B33]'>
                  <p className='text-xs'>
                    {requestData.additional_comments || "Comments"}
                  </p>
                </div>
              </div>
            }


          </div>

          {/* Buttons */}
          {requestData?.staff_status==="StaffAssigned" && 
            <div className='Buttons flex flex-wrap justify-center gap-6 w-3/4 mx-auto mt-6'>
              <button className='bg-[#FF5A5F] rounded-md px-4 py-1' onClick={acceptRequest}>Accept</button>
              <button className='bg-[#0B22B2] rounded-md px-4 py-1 text-white' onClick={rejectRequest}>Reject</button>
            </div>
          }

          {
            requestData?.staff_status==="StaffAccepted" &&
            <>
              <div className='Buttons text-center  w-3/4 mx-auto mt-6'>
                
                <p className='text-sm mt-10 mb-5'>
                  <span className='font-bold'>Note : </span>Once you've completed the task, please click the button below to confirm your completion.
                </p>
                
                <button className='bg-[#FF5A5F] rounded-md px-4 py-1' onClick={completeRequest}>Complete</button>
              </div>
            </>
          }
        
        </div>
      </div>
    }
  </>

  )
}
